import store from "../configureStore";
import allActions from "../actions";
import { containersModal } from "../../models/containersModel";
import { actionTypesContainers } from "../constants/actionTypesContainers";

const { dispatch } = store;

interface RegisteringPayload {
  isRegistering: boolean;
  containerNumber: string | null;
}

export const ContainersDispatcher = (
  actionType: actionTypesContainers,
  data: unknown,
) => {
  const containersAction = allActions.containerActions;

  switch (actionType) {
    case actionTypesContainers.ListOfContainers:
      dispatch(
        containersAction.setContainersList(data as Array<containersModal>),
      );
      break;
    case actionTypesContainers.IsContainersTableRefreshed:
      dispatch(containersAction.setIsContinersTableRefreshed(data as boolean));
      break;
    case actionTypesContainers.SelectedContainer:
      dispatch(containersAction.setSelectedContainer(data as containersModal));
      break;
    case actionTypesContainers.IsContainerRegistering:
      dispatch(
        containersAction.setIsContainerRegistering(data as RegisteringPayload),
      );
      break;
  }
};
